(() => {
  function init(scope) {
    scope.querySelectorAll('[id^="pt-testimonials-pool-"]').forEach(pool => {
      if (pool.photosReady) return;
      pool.photosReady = true;
      const hydrate = () => window.PTStyleCatalog?.hydrateImages(pool);
      if (window.Shopify?.designMode || !('IntersectionObserver' in window)) hydrate();
      else {
        const observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            observer.disconnect();
            hydrate();
          }
        }, { rootMargin: '400px 0px' });
        pool.photosObserver = observer;
        observer.observe(pool);
      }
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[id^="pt-testimonials-pool-"]').forEach(pool => pool.photosObserver?.disconnect());
  });
})();
